import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type ExperimentFlagResponse,
  experiments,
} from '../../services/payex/experiments/experiments';

type CheckFlagParams = {
  flagName: string;
  userContext?: Record<string, string | boolean | number>;
  userId?: string;
};

type CheckFlagResponse = ExperimentFlagResponse;

export const useExperimentFlag = (
  params: CheckFlagParams,
  opts: UseQueryOptions<CheckFlagResponse, unknown, boolean> = {},
): { value: boolean } => {
  const { data } = useQuery<CheckFlagResponse, unknown, boolean>(
    ['experiment-flag', params.flagName, params.userContext, params.userId],
    () =>
      experiments.checkFlag(params.flagName, params.userContext, params.userId),
    {
      select: data => !!data?.enabled,
      ...opts,
    },
  );

  return { value: data ?? false };
};
